import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  flex-grow: 1;\n  line-height: 1.3;\n  max-width: 100%;\n  padding: 1.143em;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 1.357em;\n  margin-top: 0.5714em;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      display: inline-block;\n      vertical-align: middle;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0;\n  height: ", "px;\n  width: ", ";\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled, { css } from 'styled-components';
import { FetchingStatus } from '@scp/ui-shared/core';
import { color, property, typography } from '@scp/ui-shared/theme/variables';
export var STANDARD_LOADER_CONFIG = {
  primaryColor: color.palette.grey900,
  secondaryColor: color.palette.grey800,
  speed: 1.5
};
export var shouldShowLoader = function shouldShowLoader(status) {
  return status === FetchingStatus.Loading;
};
export var ContentLoaderWrapper = styled.div(_templateObject(), function (props) {
  return props.loaderHeight;
}, function (props) {
  return props.fullWidth ? '100%' : "".concat(props.loaderWidth, "px");
}, function (props) {
  return props.as === 'span' && css(_templateObject2());
});
var MessageSkeletonWrapper = styled.div(_templateObject3());
var MessageSkeletonAvatar = styled.span(_templateObject4());
var MessageSkeletonMessage = styled.div(_templateObject5(), color.backgroundSecondary, property.borderRadius);
/**
 * TextLoader, MessageLoader and CircleLoader components
 * @example ./__docs__/content-loaders.md
 */

export var TextLoader = function TextLoader(_a) {
  var width = _a.width,
      _a$fontSize = _a.fontSize,
      fontSize = _a$fontSize === void 0 ? typography.defaultFontSize : _a$fontSize,
      _a$lineHeightRatio = _a.lineHeightRatio,
      lineHeightRatio = _a$lineHeightRatio === void 0 ? typography.defaultLineHeight : _a$lineHeightRatio,
      status = _a.status,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      id = _a.id,
      _a$as = _a.as,
      as = _a$as === void 0 ? 'div' : _a$as,
      rest = __rest(_a, ["width", "fontSize", "lineHeightRatio", "status", "children", "id", "as"]);

  if (!shouldShowLoader(status)) return children;
  var containerHeight = fontSize * lineHeightRatio;
  return React.createElement(ContentLoaderWrapper, {
    loaderWidth: width,
    loaderHeight: containerHeight,
    as: as
  }, React.createElement(ContentLoader, Object.assign({}, STANDARD_LOADER_CONFIG, {
    width: width,
    height: containerHeight,
    uniquekey: id
  }, rest), React.createElement("rect", {
    x: 0,
    y: (containerHeight - fontSize) / 2,
    rx: 0,
    ry: 0,
    width: width,
    height: fontSize
  })));
};
export var CircleLoader = function CircleLoader(_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 32 : _a$size,
      status = _a.status,
      _a$children2 = _a.children,
      children = _a$children2 === void 0 ? null : _a$children2,
      id = _a.id,
      _a$as2 = _a.as,
      as = _a$as2 === void 0 ? 'div' : _a$as2,
      rest = __rest(_a, ["size", "status", "children", "id", "as"]);

  if (!shouldShowLoader(status)) return children;
  var circleSize = size / 2;
  return React.createElement(ContentLoaderWrapper, {
    loaderWidth: size,
    loaderHeight: size,
    as: as
  }, React.createElement(ContentLoader, Object.assign({}, STANDARD_LOADER_CONFIG, {
    height: size,
    width: size,
    uniquekey: id
  }, rest), React.createElement("circle", {
    r: circleSize,
    cx: circleSize,
    cy: circleSize
  })));
};
export var MessageSkeletonLoader = function MessageSkeletonLoader(_a) {
  var _a$status = _a.status,
      status = _a$status === void 0 ? FetchingStatus.Loading : _a$status,
      _a$children3 = _a.children,
      children = _a$children3 === void 0 ? null : _a$children3,
      props = __rest(_a, ["status", "children"]);

  if (!shouldShowLoader(status)) return children;
  return React.createElement(MessageSkeletonWrapper, null, React.createElement(MessageSkeletonAvatar, null, React.createElement(CircleLoader, Object.assign({
    status: FetchingStatus.Loading
  }, props))), React.createElement(MessageSkeletonMessage, null, React.createElement(TextLoader, Object.assign({
    status: FetchingStatus.Loading,
    width: 200
  }, props)), React.createElement(TextLoader, Object.assign({
    status: FetchingStatus.Loading,
    width: 100
  }, props))));
};